import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceAcceptanceStatesService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllDeviceAcceptanceStates(page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeviceAcceptanceStates,
      queryString: `Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async createDeviceAcceptanceStates(name) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.DeviceAcceptanceStates
    }, {
      name: name
    });
    return await firstValueFrom(observable);
  }

  async updateDeviceAcceptanceStates(id, name) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.DeviceAcceptanceStates
    }, {
      id: id,
      name: name
    });
    return await firstValueFrom(observable);
  }

}
